import React, {useState} from 'react';
import { HiX, HiMenu } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { navigationItems } from '../../constants';

import { images } from '../../constants';

import './Navbar.scss';

const Navbar = () => {

  // const navigationItems = ['home', 'about', 'work', 'skills', 'contact'];
  const [currentComp, setCurrentComp] = useState('home');
 
  function updateCurrentComp() {
    setTimeout(()=>{
      setCurrentComp(window.location.hash.slice(1));
    }, 200)
    
  }

  window.addEventListener('scroll', ()=>{
    const yPos = window.scrollY;


    const totalHeight = window.innerHeight;
    const currIdx = Math.round(yPos / totalHeight);
    setTimeout(()=>{
      setCurrentComp(navigationItems[currIdx]);
    }, 200) 
  })



  const [toggle, setToggle] = useState(false)
  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.logo} alt='logo'/>
      </div>
      <ul className='app__navbar-links'>
       {['home', 'about', 'work', 'skills', 'contact'].map((item)=> (
        <li className='app__flex p-text' key={`link-${item}`}>
          <div />
          <a 
          href={`#${item}`} 
          style={currentComp === item ? {color: 'var(--accent-color)'} : {} }
          onClick={()=> updateCurrentComp()}
          > {item} </a>
        </li>
       ))}
      </ul>


      <div className='app__navbar-menu'>
        <HiMenu onClick={()=> setToggle(true)}/>
        {
          toggle && (
            <motion.div 
              whileInView = {{ x: [300, 0] }}
              transition = {{ duration: 0.85, ease: 'easeOut' }}
              >
              
              <HiX onClick={()=> setToggle(false)}/>
              <ul>
              {['home', 'about', 'work', 'skills', 'contact'].map((item)=> (
              <li key={{item}}>
                
                <a href={`#${item}`} onClick={()=> setToggle(false)}> {item} </a>
              </li>
              ))}
              </ul>


            </motion.div>
          )
        }
      </div>
    </nav>
  )
}

export default Navbar